<template lang="html">

	<section class="producto-home -snacks column-center" id="snacks">

		<div class="container container-title animation">
			<!-- <h1 class="big-title animation" id="titulo-split" data-splitting="chars">{{$t('header.snack')}}</h1> -->
			<h2 class="big-title animation" id="titulo-split">{{$t('header.snack')}}</h2>
		</div>

		<div class="contenedor-ruleta animation">
			<template v-for="producto in productos">
				<router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.snacks')+'/'+producto" v-if="producto != 'inicial'" :activo="select == producto" @mouseover.native="select = producto" class="boton" :el="producto">
					<img :src="'/static/img/logos/'+producto+'-w.png'" class="white" :alt="'logo '+producto">
					<img :src="'/static/img/logos/'+producto+'.png'" class="color" :alt="'logo '+producto">
				</router-link>
			</template>

			<router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.palomitas')" :activo="select == 'palomitas'" @mouseover.native="select = 'palomitas'" class="boton" el="palomitas">
				<img src="/static/img/logos/palomitas-w.png" class="white" alt="logo de palomitas">
				<img src="/static/img/logos/palomitas.png" class="color" alt="logo de palomitas">
			</router-link>

			<router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.mios')" :activo="select == 'mios'" @mouseover.native="select = 'mios'" class="boton" el="mios">
				<img src="/static/img/logos/mios.png" class="white" alt="logo de mios">
				<img src="/static/img/logos/mios-b.png" class="color" alt="logo de mios">
			</router-link>

			<router-link :to="'/' + $i18n.locale + '/' + $t('enlaces.jummy')" :activo="select == 'jummy'" @mouseover.native="select = 'jummy'" class="boton" el="jummy">
	          <img src="/static/img/logos/jummy-w.png" class="blanco" alt="logo de jummy">
	          <img src="/static/img/logos/jummy.png " class="color" alt="logo de jummy">
	        </router-link>

			<router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.otrosProductos')" :activo="select == 'otros-productos'" @mouseover.native="select = 'otros-productos'" class="boton" el="otros-productos">
				<img src="/static/img/logos/otros-productos.png" class="white" alt="logo de otros productos">
				<img src="/static/img/logos/otros-productos-w.png" class="color" alt="logo de mios">
			</router-link>

			<div class="contenedor-imagen row-center">

				<template v-for="producto in productos">
					<img v-show="select == producto" class="animated bounceIn" :src="'/static/img/ruleta-home/snacks/'+producto+'.png'" :el="producto" :alt="'imagen de '+producto">
				</template>

				<div class="contenedor-multiples-imagenes" v-show="select == 'mios'">
					<img class="animated bounceIn" data="bounceIn" :src="'/static/img/ruleta-home/snacks/mios.png'" alt="mios" el="mios">
				</div>



				<div class="contenedor-multiples-imagenes" v-show="select == 'palomitas'">
					<img class="animated bounceIn" data="bounceIn" :src="'/static/img/ruleta-home/snacks/palomitas.png'" el="palomitas" alt="Imagen de palomitas clasicas">
					<img class="animated bounceIn" data="bounceIn" :src="'/static/img/ruleta-home/snacks/palomitas-mostaza.png'" el="palomitas-mostaza" alt="Imagen de palomitas-mostaza">
				</div>

				<div class="contenedor-multiples-imagenes" v-show="select == 'otros-productos'">
					<img class="animated bounceIn" data="bounceIn" :src="'/static/img/ruleta-home/snacks/pajitas.png'" el="pajitas" alt="imagen de pajitas">
					<img class="animated bounceIn" data="bounceIn" :src="'/static/img/ruleta-home/snacks/buscalios.png'" el="buscalios" alt="imagen de buscalios">
					<img class="animated bounceIn" data="bounceIn" :src="'/static/img/ruleta-home/snacks/tejitas.png'" el="tejitas" alt="imagen de tejitas">
					<img class="animated bounceIn" data="bounceIn" :src="'/static/img/ruleta-home/snacks/trikers.png'" el="trikers" alt="imagen de trikers">
					<img class="animated bounceIn" data="bounceIn" :src="'/static/img/productos/surtis.png'" el="surtis" alt="imagen de surtis">
				</div>

			</div>


		</div>

		<div class="contenedor-boton">
			<espiral class="espiral-ani" delay="0"></espiral>
			<router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.snacks')" class="btn -action waypoints" v-html="$t('todosNuestrosSnacks')"></router-link>
		</div>


		<div class="contenedor-sin-gluten">
			<espiral class="espiral-ani" delay="0"></espiral>
			<img src="/static/img/sin_gluten.svg" class="sin_gluten waypoints" alt="sin gluten">
			<p class="yummy waypoints">{{$t('sinGluten')}}</p>
		</div>


		<img class="palomita-to-left" src="/static/img/palomita-to-left.png" alt="">
		<img class="bola-ketchup" src="/static/img/bola-ketchup.png" alt="">

		<img class="personajes-risketos" src="/static/img/personajes-risketos.png" alt="">

		<img class="gusanito-esquina" src="/static/img/gusanito-esquina.png" alt="">


	</section>

</template>

<script lang="js">

	import espiral from '@/components/parts/icons/espiral'

	export default {
		name: 'home',
		data() {
			return {
				select: 'gusanitos',
				productos: ['gusanitos', 'match-ball', 'triskys', 'risketos', 'jummy']
			}
		},
		components: {
			'espiral': espiral
		}

	}
</script>

<style scoped lang="scss">
	.producto-home {
		background-image: linear-gradient(178deg, #ffca00, #feb600);
	}

	.animated.bounceIn {
		&[el="match-ball"] {
			width: 82%
		}
	}

	.bola-ketchup {
		position: absolute;
		left: 70%;
		bottom: 100px;
		max-width: 150px;
	}

	.palomita-to-left {
		position: absolute;
		left: 100px;
		top: 50px;
		max-width: 150px;
	}

	.personajes-risketos {
		max-width: 300px;
		position: absolute;
		left: 50px;
		bottom: 50px;
	}

	.gusanito-esquina {
		position: absolute;
		right: 0;
		top: 200px;
		max-width: 100px;
	}

	.boton {
		&[el=gusanitos] {
			top: 0;
			left: 50%;
			margin-left: -100px;
		}

		&[el=palomitas] {
			right: 0;
			top: 60px;
		}

		&[el=mios] {
			top: 50%;
			margin-top: -60px;
			right: 0;
		}


		&[el=jummy] {
			bottom: 60px;
			right: 0;
		}

		&[el=otros-productos] {
			bottom: -30px;
			left: 50%;
			margin-left: -150px;
			transition: .5s;
			width: 300px;

			h2 {
				font-size: 33px;
				text-transform: uppercase;
				color: #fff;
				font-family: 'Futura LT CondensedExtraBold';
				line-height: 1em;
				transform: rotate(-9deg);

				span {
					font-family: 'Futura LT CondensedExtraBold';
					font-size: 28px;
					line-height: 1em;
				}

				&:hover {
					color: #000;
				}
			}
		}

		&[el=match-ball] {
			left: 0;
			bottom: 60px;

		}

		&[el=triskys] {
			left: 0;
			top: 50%;
			margin-top: -60px;
		}

		&[el=risketos] {
			left: 0;
			top: 60px;
		}

		&[el=patatas] {
			right: 0px;
			bottom: 60px;
		}
	}

	@for $i from 1 through 7 {
		.boton:nth-child(#{$i}) {
			animation-delay: #{$i / 5 + 2}s;
		}
	}



	@function randomNum($min, $max) {
		$rand: random();
		$randomNum: $min +floor($rand * (($max - $min) + 1));

		@return $randomNum;
	}

	.contenedor-ruleta.launched~.imagenes-decoracion {
		* {
			opacity: 1;
		}

		@for $i from 1 through 12 {
			*:nth-child(#{$i}) {
				animation: float-#{randomNum(1, 4)} #{randomNum(6, 12)}s ease-in-out infinite;

			}
		}
	}

	.contenedor-multiples-imagenes {
		display: inline-block;
		width: 444px;
		height: 434px;
		position: relative;

		img {
			position: absolute;
			left: 0;
			top: 0;

			&[el=onduladas] {
				animation-delay: .5s;
			}

			&[el=buscalios] {
				animation-delay: .3s;
			}

			&[el=tejitas] {
				animation-delay: .6s;
			}

			&[el=trikers] {
				animation-delay: 1s;
			}

			&[el=surtis] {
				animation-delay: 1.4s;
				max-width: 55%;
				transform: rotate(18deg) translate(115px, 60px) !important;
				position: relative;
			}

			&[el=palomitas-mostaza] {
				animation-delay: .5s;
			}

			&[el=match-ball] {
				width: 86%
			}
		}
	}

	.contenedor-texto {
		position: absolute;
		right: -50px;
		bottom: 0;
		width: 300px;
		height: auto;
		padding-top: 200px;
		transform: rotate(20deg);

		.contenedor-espiral {
			position: absolute;
			left: -60px;
			top: 20px;
			transform: scale(.8) rotate(-20deg) rotateY(-180deg);
		}

		p {
			font-size: 36px;
			color: white;
			display: inline-block;
			line-height: 30px;
			margin-top: 30px;
			animation-delay: 2s;
			max-width: 200px;
		}
	}

	.btn {
		font-size: 50px;
		max-width: fit-content;
		height: 80px;
		line-height: 70px;

		span {
			font-size: 16px;
		}
	}

	@media screen and (max-width: 1400px) {
		.personajes-risketos {
			max-width: 250px;
			left: 20px;
			bottom: 20px;
		}
	}

	@media screen and (max-width: 1150px) {
		.palomita-to-left {
			left: 50%;
			top: 20px;
		}

		.personajes-risketos {
			display: none;
		}
	}

	@media screen and (max-width: 900px) {
		.contenedor-texto {
			display: none;
		}

		.contenedor-sin-gluten {
			display: none;
		}

		.palomita-to-left {
			left: 20px;
			top: auto;
			bottom: 20px;
		}

		.gusanito-esquina {
			top: 40px;
		}

		.bola-ketchup {
			right: 20px;
			left: auto;
		}

	}

	@media screen and (max-width: 500px) {
		.gusanito-esquina {
			top: 200px;
			max-width: 70px;
		}

		.bola-ketchup {
			right: 0px;
			left: auto;
			bottom: 320px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/views/home/modulo-snacks.vue